export function reInitJcf4() {
    $(".form-section-get-started").on("change", "select", function() {
        jcf.setOptions({
            wrapNative: false,
            fakeDropInBody: false,
            maxVisibleItems: 6,
            useCustomScroll: true
        });

        setTimeout(function () {
            let selects = $("select:not(.jcf-hidden)");
            jcf.replace(selects);
        }, 500);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/contact-form-get-started.js